import moment from "moment";

function filterEpisodesToday(episodes, today) {
    const todayStart = moment(today.format('YYYY-MM-DD') + ' 00:00:00').unix();
    const todayStop = moment(today.format('YYYY-MM-DD') + ' 23:59:59').unix();

    return episodes.filter((episode) => episode.timeStop() > todayStart && episode.timeStart() < todayStop);
}

export default function ($app) {
    this.isShow = ko.observable(false);

    this.show = () => this.isShow(true);
    this.hide = () => this.isShow(false);

    this.selectedDay = ko.observable($app.event().days().find(day => day.format('YYYY-MM-DD')===moment().format('YYYY-MM-DD') ) || $app.event().days()[0]);
    this.selectedStream = ko.observable($app.event().stream()[0]);

    this.days = ko.computed(() => $app.event().days());

    this.selectDay = (day) => {
        this.selectedDay(day);
        this.selectStream(
            $app.event().stream().find((stream) => filterEpisodesToday(stream.episode(), this.selectedDay()).length > 0)
            || $app.event().stream()[0]
        );
    };

    this.selectStream = (stream) => this.selectedStream(stream);

    this.streams = ko.computed(() => filterEpisodesToday($app.event().stream(), this.selectedDay()));

    this.episodes = ko.computed(() => {
        return $app.event().episode().filter((episode) => {
            const episodeTime = moment.unix(episode.timeStart());
            const isSelectedDay = episodeTime.format('YYYY-MM-DD') === this.selectedDay().format('YYYY-MM-DD');
            const isSelectedStream = episode.streamId() === this.selectedStream().id();

            return isSelectedDay && isSelectedStream;
        });
    });
}
